import React from 'react';
import metaOverrideSet from 'Views/Page/Content/Templates/BigPickListTemplate/MetaOverrideSet';
import WizardStepWrapperTemplate from 'Views/Page/Content/Templates/WizardTemplates/WizardStepWrapperTemplate';
import FundingInstructionFundingTypeTemplate from './FundingInstructionFundingTypeTemplate';

export default function FundingInstructionsFundingTypeWizardStep({
  resource,
}) {
  return <>
    <WizardStepWrapperTemplate
      metaOverrideSet={metaOverrideSet}
      resource={resource}
      layout={FundingInstructionFundingTypeTemplate}
    />
  </>;
}
